import React, { useEffect, useState } from 'react';
import './publication.css'
import client from '../../utils/prismicHelpers';
import * as queries from "../../utils/prismicQueries";
import video from "../../assets/video/unsplash_50GSjnC7qXw.png"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronRight } from '@fortawesome/free-solid-svg-icons';
import PublicationCard from './PublicationCard';

import BreadCrumb from '../../main/components/BreadCrumb';
const Publication = () => {

    const [newsSlider, setNewsSlider] = useState(null);
    const [newsContent, setNewsContent] = useState(null);

    useEffect(() => {
        client
            .query({
                query: queries.news,
            })
            .then((response) => {
                const partnersContent = response.data.allNewss.edges[0].node;
                setNewsContent(partnersContent);
                setNewsSlider(partnersContent.slider_info);
                window.scrollTo(0, 0);

            })
            .catch((error) => {
                console.error(error);
            });
    });


//     const [publication, setPublication] = useState(null);

//     useEffect(() => {
//         client
//             .query({
//                 query: queries.publication,
//             })
//             .then((response) => {
//                 const publicationDoc = response.data.allPublications.edges[0].node;
//                 setPublication(publicationDoc);
    

//             })
//             .catch((error) => {
//                 console.error(error);
//             });
//     });
// console.log(publication);



    return (
        <section style={{ backgroundImage: `url(${newsContent?.news_bg?.url})` }} className='news-container '>
            <div className="container">
            <BreadCrumb nested={"PUBLICATIONS"} />
            
                <h3 className="subtitle">{"Publications"}</h3>
                <div>
                <div className=" publication-card-container ">
                <div className="pb-0">
                    <h6 className="">Exploiting Application Tolerance for Functional Safety</h6>
                    <p className="institute-text">IEEE International Test Conference</p>

                </div>
                <div >
                    <p className="text-muted pb-1">Prasanth V P, Rubin Parekhji, Bharadwaj Amrutur</p>
                    <div className="  d-flex justify-content-between">
                        <small className="muted-text">2021</small>
                        <p className=" m-0 p-0 read-more">Read More  <span className="ms-1"><FontAwesomeIcon icon={faChevronRight} /></span></p>
                    </div>
                </div>
            </div>
                </div>

                <div className="post-container pt-2">
                    <div className="row g-3 mt-2">
                        {[1, 3, 4, 5, 6, 1, 2, 3, 4].map((info, index) => <PublicationCard key={index} />)}
                        <nav className="d-flex justify-content-center my-5" aria-label="Page navigation example " >
                            <ul className="pagination ">
                                <li className="page-item mx-2"><a className="page-link" href="#">1</a></li>
                                <li className="page-item mx-2"><a className="page-link" href="#">2</a></li>
                                <li className="page-item mx-2"><a className="page-link" href="#">3</a></li>
                                <li className="page-item mx-2">
                                    <a className="page-link" href="#" aria-label="Next">
                                        <span ><FontAwesomeIcon icon={faChevronRight} /></span>
                                    </a>
                                </li>
                            </ul>
                        </nav>

                    </div>
                </div>


            </div>
        </section>

    );
};

export default Publication;